import css from 'styled-jsx/css';
import { pageWidth } from 'styles/css-constants';
import { sharedPalette, warmGrays } from 'styles/colors/constants';
import { sansSerif } from 'styles/css-constants';
import { MQ_MEDIUM, MQ_LARGE, MQ_MIDLARGE } from 'constants/mq';
import { hexToRgbValues, rgbaToHslaValues } from 'util/colors';

export default css`
  .SiteHeader {
    position: relative;
    z-index: 1000;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
  }

  .SiteHeader__actions {
    margin: 0 1rem;
    display: flex;
  }

  .SiteHeader__cancelBtnContainer {
    display: flex;
    justify-content: center;
  }

  .SiteHeader__cancelBtnContainer button {
    display: inline-block;
    padding: 0.5rem 0.5rem;
    background-color: ${sharedPalette.watermelon};
    color: #fff;
    font-size: var(--fontScaleNeg2);
    text-align: center;
    text-transform: uppercase;
    outline: none;
    cursor: pointer;
    min-height: 38px;
  }

  .SiteHeader__icon {
    color: ${warmGrays[7]};
    font-size: 20px;
  }

  .SiteHeader__icon:hover {
    color: ${warmGrays[9]};
  }

  .SiteHeader__icon--recipeBox,
  .SiteHeader__icon--visionBoards {
    font-size: 40px;
  }

  .SiteHeader__logo {
    flex: 1 0 0px;
    margin: 0.5rem 0 0.5rem 1rem;
    display: flex;
    align-items: flex-end;
  }

  .SiteHeader__logo :global(a) {
    display: flex;
    justify-content: flex-start;
  }

  .SiteHeader__logo :global(svg) {
    display: block;
    height: 22px;
  }

  .SiteHeader__logo span {
    font-size: 15px;
    text-transform: uppercase;
    padding-left: 1rem;
  }

  .SiteHeader__nav {
    flex: 0 0 100%;
    border-top: 1px solid ${warmGrays[0]};
  }

  .SiteHeader__nav :global(.SiteHeader__nav-item:nth-child(n + 4)) {
    display: none;
  }

  .SiteHeader__recipebox {
    position: relative;
    width: 36px;
    display: flex;
    justify-content: flex-end;
  }

  .SiteHeader__recipebox--isSignedIn :global(svg) {
    color: ${sharedPalette.watermelon};
  }

  .SiteHeader__recipebox :global(svg) {
    width: 20px;
    height: 20px;
  }

  .SiteHeader__recipebox a {
    color: ${warmGrays[7]};
    align-self: center;
  }

  .SiteHeader__recipeBoxHeader {
    display: flex;
    color: ${warmGrays[7]};
    letter-spacing: 0.02em;
    text-transform: uppercase;
    padding: 10px 0;
  }

  .SiteHeader__recipeBoxHeader :global(svg) {
    margin-right: 0.25rem;
    width: 12rem;
    height: 1rem;
  }

  .SiteHeader__search {
    display: none;
  }

  .SiteHeader__search-button {
    display: flex;
    align-items: center;
    padding-left: 1rem;
  }

  .SiteHeader__searchBoxContainer {
    display: flex;
    width: 100%;
  }

  .SiteHeader__user {
    display: flex;
    position: relative;
    width: 36px;
  }

  @supports (-webkit-touch-callout: none) {
    /* CSS specific to iOS devices */
    .SiteHeader__cancelBtnContainer button {
      min-height: 34px;
    }
  }

  @media screen and ${MQ_MEDIUM} {
    .SiteHeader__recipeBoxHeader :global(svg),
    .SiteHeader__visionBoardHeader :global(svg) {
      height: 1.2rem;
    }

    .SiteHeader {
      /* explicit height for as reference for positioning the flyout */
      height: 70px;
    }

    .SiteHeader--no-nav {
      height: inherit;
    }

    .SiteHeader__actions {
      margin-right: 1.5rem;
    }

    .SiteHeader__logo {
      margin-left: 1.5rem;
    }

    .SiteHeader__logo :global(svg) {
      height: 24px;
    }
  }

  @supports (display: grid) {
    .SiteHeader--centered {
      display: grid;
      grid-template: '. logo actions'/ 1fr auto 1fr;
      justify-items: center;
    }

    .SiteHeader--centered .SiteHeader__actions {
      grid-area: actions;
    }

    .SiteHeader--centered .SiteHeader__logo {
      grid-area: logo;
      margin-right: 0;
      margin-left: 0;
    }

    @media screen and ${MQ_LARGE} {
      .SiteHeader {
        display: grid;
        grid-template:
          '... logo actions ...'
          'nav nav  nav     nav' / 1fr 488px 488px 1fr;
        /* explicit height for as reference for positioning the flyout */
        height: 80px;
      }

      .SiteHeader--no-nav {
        height: inherit;
      }

      .SiteHeader__actions {
        grid-area: actions;
        justify-self: end;
        margin-right: 0;
        display: flex;
        align-items: center;
      }

      .SiteHeader__logo {
        grid-area: logo;
        margin-left: 0;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }

      .SiteHeader__logo span {
        font-size: 25px;
        text-transform: uppercase;
        padding-left: 2rem;
      }

      .SiteHeader__logo :global(svg) {
        height: 36px;
      }

      .SiteHeader__nav {
        grid-area: nav;
      }

      .SiteHeader__recipeBoxHeader,
      .SiteHeader__visionBoardsHeader {
        font-size: 21px;
      }

      .SiteHeader__search,
      .SiteHeader__user {
        display: initial;
      }

      .SiteHeader__search {
        width: 360px;
      }

      .SiteHeader__search-button {
        display: none;
      }

      .SiteHeader__user {
        margin-right: 1.5rem;
      }

      .SiteHeader :global(.SiteHeaderNav) {
        margin-right: auto;
        margin-left: auto;
        width: ${pageWidth.large};
      }

      .SiteHeader--recipeBox,
      .SiteHeader--visionBoards {
        grid-template-columns: 1rem 50vw 49vw 1rem;
      }
    }

    @media screen and ${MQ_MIDLARGE} {
      .SiteHeader {
        grid-template-columns: 1fr 574px 574px 1fr;
      }

      .SiteHeader--recipeBox,
      .SiteHeader--visionBoards {
        grid-template-columns: 1rem 55vw 44vw 1rem;
      }

      .SiteHeader :global(.SiteHeaderNav) {
        width: ${pageWidth.midlarge};
      }
    }
  }

  /* Recipe Box Header Styles */
  .SiteHeader--recipeBox {
    z-index: 2; /* the header needs to be above the teasers but below the "Edit" modal */
    display: grid;
    grid-template:
      'logo recipeBox actions'
      / 1fr auto 1fr;
    align-items: end;
    background-color: transparent;
    border-top: 1px solid ${warmGrays[0]};
  }

  .SiteHeader--recipeBox .SiteHeader__logo {
    grid-area: logo;
  }

  .SiteHeader--recipeBox .SiteHeader__recipeBoxHeader {
    grid-area: recipeBox;
  }

  .SiteHeader--recipeBox .SiteHeader__actions {
    grid-area: actions;
    justify-content: flex-end;
  }

  @media screen and ${MQ_MEDIUM} {
    .SiteHeader--recipeBox {
      background-color: transparent;
    }
  }

  @media screen and ${MQ_LARGE} {
    .SiteHeader--recipeBox {
      grid-template:
        '. logo recipeBox actions .'
        / 1rem 1fr auto 1fr 1rem;
    }

    .SiteHeader--recipeBox :global(.AccountLink__button) {
      font-size: 25px;
    }

    .SiteHeader--recipeBox .SiteHeader__user {
      margin-right: 0;
      width: auto;
    }
  }

  /* Vision Boards Header Styles */
  .SiteHeader--visionBoards {
    z-index: 2; /* the header needs to be above the teasers but below the "Edit" modal */
    display: grid;
    grid-template:
      'logo visionBoards actions'
      / 1fr auto 1fr;
    align-items: center;
    background-color: transparent;
    border-top: 1px solid ${warmGrays[0]};
  }

  .SiteHeader--visionBoards .SiteHeader__logo {
    grid-area: logo;
    max-width: 80px;
  }

  .SiteHeader--visionBoards .SiteHeader__visionBoardsHeader {
    grid-area: visionBoards;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    font-size: 22px;
    font-family: ${sansSerif};
    letter-spacing: 0.02em;
  }

  .SiteHeader--visionBoards .SiteHeader__visionBoardsHeader span {
    margin-left: 0.5rem;
  }

  .SiteHeader--visionBoards .SiteHeader__actions {
    grid-area: actions;
    justify-content: flex-end;
  }

  @media screen and ${MQ_MEDIUM} {
    .SiteHeader--visionBoards {
      background-color: transparent;
    }
  }

  @media screen and ${MQ_LARGE} {
    .SiteHeader--visionBoards {
      grid-template:
        '. logo visionBoards actions .'
        / 1rem 1fr auto 1fr 1rem;
    }

    .SiteHeader--visionBoards .SiteHeader__visionBoardsHeader {
      font-size: 26px;
    }

    .SiteHeader--visionBoards :global(.AccountLink__button) {
      font-size: 25px;
    }

    .SiteHeader--visionBoards .SiteHeader__user {
      margin-right: 0;
      width: auto;
    }
  }

  /* Search Page Header Styles */
  @media screen and ${MQ_MEDIUM} {
    .SiteHeader--searchPage {
      background-color: transparent;
    }
  }
`;

// Make a shade of watermelon
const watermelonRgb = hexToRgbValues(sharedPalette.watermelon);
const watermelonHsla = rgbaToHslaValues(
  watermelonRgb.red,
  watermelonRgb.green,
  watermelonRgb.blue,
  1
);
watermelonHsla.lightness *= 0.75;

export const accountLinkStyles = css`
  .AccountLink {
    position: relative;
  }

  :global(.AccountLink__button) {
    display: block;
    padding: 0.5rem 0 0.5rem 1rem;
    background-color: transparent;
    color: ${warmGrays[7]};
    font-size: 20px;
    overflow: hidden;
    cursor: pointer;
  }

  .AccountLink__navItem {
    display: block;
    padding: 0.375rem 0.5rem;
    color: ${warmGrays[9]};
    font-size: var(--fontScaleNeg3);
    letter-spacing: 0.02em;
    text-align: center;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .AccountLink__navLogout {
    margin: 0.25rem 0 0;
    border-top: 1px solid ${warmGrays[1]};
    padding-top: 0.5rem;
  }

  .AccountLink__button--signedIn {
    color: ${sharedPalette.watermelon};
  }

  .AccountLink__button--signedIn:hover {
    color: hsl(
      ${watermelonHsla.hue},
      ${watermelonHsla.saturation}%,
      ${watermelonHsla.lightness}%
    );
  }

  @media screen and ${MQ_LARGE} {
    .AccountLink__navItem {
      font-size: calc(var(--fontScaleNeg1) / 1.125);
    }
  }

  /* Tooltip styles */
  .AccountLink__button + :global(.Tooltip) {
    top: 28px;
    right: -1rem;
    padding: 0.5rem 0.75rem;
  }

  .AccountLink__button + :global(.Tooltip::after) {
    right: 1rem;
    left: auto;
    transform: none;
  }
`;
